import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { DeactivateAccountModal, DeactivateAccountWidgetStep } from './types';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/actionCreators';
import { createNetworkRequestActionSetWithSuppliedData } from '../utils';
import {
  PapiRequestSettingsDeactivationConfirm,
  PapiRequestSettingsDeactivationReactivate,
  PapiRequestSettingsDeactivationSend,
  PapiSettingsDeactivationConfirm,
  PapiSettingsDeactivationReactivate,
  PapiSettingsDeactivationSend,
} from '@wix/da-papi-types';

export const setDeactivateAccountWidgetStep = createAction(
  `${reduxKey}.SET_DEACTIVATEACCOUNT_WIDGET_STEP`,
  (step: DeactivateAccountWidgetStep) => ({ step })
);

export const pushSendVerificationEmailModal = () =>
  pushModal(DeactivateAccountModal.SendVerificationEmail, {
    wrapInModal: false,
  });

export const pushConfirmDeactivationModal = () =>
  pushModal(DeactivateAccountModal.ConfirmDeactivation, {
    wrapInModal: false,
  });

export const {
  submit: submitSendVerificationEmailModal,
  success: submitSendVerificationEmailModalSuccess,
  failure: submitSendVerificationEmailModalFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettingsDeactivationSend,
  PapiSettingsDeactivationSend
>(reduxKey, 'SUBMIT_SEND_VERIFICATION_EMAIL_MODAL');

export const {
  submit: submitConfirmDeactivationModal,
  success: submitConfirmDeactivationModalSuccess,
  failure: submitConfirmDeactivationModalFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  Pick<
    PapiRequestSettingsDeactivationConfirm,
    'preset_reason' | 'other_reason'
  >,
  PapiSettingsDeactivationConfirm
>(reduxKey, 'SUBMIT_CONFIRM_DEACTIVATION_MODAL');

export const {
  submit: submitReactivate,
  success: submitReactivateSuccess,
  failure: submitReactivateFailure,
} = createNetworkRequestActionSetWithSuppliedData<
  PapiRequestSettingsDeactivationReactivate,
  PapiSettingsDeactivationReactivate
>(reduxKey, 'SUBMIT_REACTIVATE');
